import React, { useEffect, useState } from 'react';
import useFetch from 'use-http';

// Configuration
import { MAIN_API_URL } from '../../../configuration';

// Recharts
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

// Kit
import { Card } from '@/components/ui';

import { useMediaQuery } from '@mui/material';
import { connect } from 'react-redux';
import { translateLabels } from '../../../helpers/translateLabels';

const PerformanceComponent = (props) => {

    const { error, get, response } = useFetch(`${MAIN_API_URL}/stats`, {
        headers: {
            "x-token": `${localStorage.getItem("token")}`
        }
    });

    const { startDate, endDate } = props;

    const [data, setData] = useState([]);

    const matches = useMediaQuery('(min-width: 500px)');

    useEffect(() => { getStatsClicks(); }, [startDate, endDate]);

    const getStatsClicks = async () => {
        const resp = await get("/clicks?startDate=" + startDate + "&endDate=" + endDate);
        if (response.ok) {
                const values = resp.data.values;
                const d = [];
                const labelsInFormat = translateLabels(resp.data.labelsValues, resp.data.groupedBy, 'es');
                for (let i = 0; i < values.length; i++) {

                    const newData = {
                        Name: labelsInFormat[i],
                        Clicks: values[i].y
                    };

                    d.push(newData);
                }

                setData([...d]);
        } else {
            console.log(error);
        }
    }

    return (
        <Card hover className="flex h-[360px] flex-col p-5 text-left sm:h-[420px]">
            <div className="mb-2 flex items-center justify-between">
                <h2 className="text-[17px] font-bold leading-tight tracking-[-0.01em] text-foreground sm:text-lg">
                    Clientes atendidos
                </h2>
            </div>
            <div className="-ml-2 min-h-0 flex-1">
                <ResponsiveContainer minWidth={350}>
                    <AreaChart
                        data={data}
                        margin={{
                            left: matches ? 0 : -16,
                            right: 20,
                            bottom: 0,
                            top: 10,
                        }}
                    >
                        <defs>
                            <linearGradient id="perfGrad" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="5%" stopColor="#0DA15A" stopOpacity={0.25} />
                                <stop offset="95%" stopColor="#0DA15A" stopOpacity={0} />
                            </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" stroke="#EAE8F4" vertical={false} />
                        <XAxis dataKey="Name" tick={{ fill: 'var(--muted-foreground)', fontSize: 12 }} tickLine={false} axisLine={{ stroke: 'var(--border)' }} />
                        <YAxis tick={{ fill: 'var(--muted-foreground)', fontSize: 12 }} tickLine={false} axisLine={false} width={32} />
                        <Tooltip
                            contentStyle={{
                                borderRadius: 12,
                                border: '1px solid var(--border)',
                                boxShadow: '0 4px 12px -4px rgba(38,34,84,0.13)',
                                fontFamily: 'Poppins, sans-serif',
                                fontSize: 13,
                            }}
                        />
                        <Area type="monotone" dataKey="Clicks" stroke="#0DA15A" strokeWidth={2.5} fillOpacity={1} fill="url(#perfGrad)" />
                    </AreaChart>
                </ResponsiveContainer>
            </div>
        </Card>
    )
}

const mapStateToProps = state => {
    return {
        startDate: state.employees.filterDates.startDate,
        endDate: state.employees.filterDates.endDate,
    }
}

export default connect(mapStateToProps, null)(PerformanceComponent);
